var __TEMP__ = require('./_createFind.js');var createFind = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./findLastIndex.js');var findLastIndex = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = findLast;
